export default {"src":"/_next/static/media/app_store_badge.b7a32385.svg","height":40,"width":120};